/* Lazy loads /recommendations/products into <kora-recommendations> when it approaches the viewport. */
(() => {
  if (customElements.get('kora-recommendations')) return;
  class KoraRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.querySelector('.card')) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.load(); }
      }, { rootMargin: '300px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    async load() {
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const source = doc.querySelector('kora-recommendations');
        if (!source || !source.querySelector('.card')) return;
        this.innerHTML = source.innerHTML;
      } catch (e) { /* stay hidden */ }
    }
  }
  customElements.define('kora-recommendations', KoraRecommendations);
})();
